/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HorseColor
 */
export interface HorseColor {
    /**
     * 
     * @type {number}
     * @memberof HorseColor
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof HorseColor
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HorseColor
     */
    shortcut?: string | null;
}

/**
 * Check if a given object implements the HorseColor interface.
 */
export function instanceOfHorseColor(value: object): value is HorseColor {
    return true;
}

export function HorseColorFromJSON(json: any): HorseColor {
    return HorseColorFromJSONTyped(json, false);
}

export function HorseColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): HorseColor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'shortcut': json['shortcut'] == null ? undefined : json['shortcut'],
    };
}

export function HorseColorToJSON(json: any): HorseColor {
    return HorseColorToJSONTyped(json, false);
}

export function HorseColorToJSONTyped(value?: HorseColor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'shortcut': value['shortcut'],
    };
}

